import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink, Link, Route, Navigate } from 'react-router-dom';
import Layout from '../Dashboard/Layout';
import "../Dashboard/Dashboard.css";
import { TenantAdminProvider } from './shared';
import { Overview, Organization, Subscription } from './TenantPages';
import Employees from './Employees';
import Sso from './Sso';
import { ReactComponent as OrganizationIcon } from '../Icons/shape-folder-open.svg';
import { ReactComponent as UsersIcon } from '../Icons/AllTools.svg';
import { ReactComponent as LockIcon } from '../Icons/lockRaw.svg';
import { ReactComponent as ListIcon } from '../Icons/notepad.svg';
import { ReactComponent as ToggleIcon } from '../Icons/Slide_in.svg';
import './TenantAdmin.css';
import AnalyticsDashboard from '../Analytics/AnalyticsDashboard';
import AuditPage from '../Audit/AuditPage';
import { ReactComponent as SlideIn } from "../Icons/Slide_in.svg";


function Navigation({ collapsed, toggleSidebar }) {
  return <aside className={'ta-navigation' + (collapsed ? ' ta-collapsed' : '')}>
    <ButtonToggle collapsed={collapsed} onClick={toggleSidebar} />
    {!collapsed && <><p className="ta-nav-title">Tenant administration</p><Nav as="nav" aria-label="Tenant administration">
      {[
        ['overview', 'Overview', ListIcon], ['analytics', 'Analytics', ListIcon], ['audit', 'Audit', ListIcon], ['employees', 'Employees', UsersIcon],
        ['sso', 'SSO', LockIcon], ['organization', 'Organization', OrganizationIcon],
        ['subscription', 'Subscription', ListIcon],
      ].map(([path, title, Icon]) => <Nav.Link as={NavLink} key={path} to={`/app/admin/${path}`}><Icon aria-hidden="true" />{title}</Nav.Link>)}
      <Nav.Link as={Link} to="/app/tools">Back to developer tools</Nav.Link>
    </Nav></>}
  </aside>;
}
function ButtonToggle({ collapsed, onClick }) {
  return <button className="auth-link-button ta-nav-toggle" aria-label={collapsed ? 'Expand admin navigation' : 'Collapse admin navigation'} onClick={onClick}>        <SlideIn className="slideicon" />
  </button>;
}
export default function TenantAdminShell() {
  return <TenantAdminProvider><div className="tenant-admin-shell"><Layout navigation={Navigation} /></div></TenantAdminProvider>;
}

// Used inside the existing TENANT_ADMIN guard; platform routing is untouched.
export function tenantAdminRoutes() {
  return <Route path="/app/admin" element={<TenantAdminShell />}>
    <Route index element={<Navigate replace to="overview" />} />
    <Route path="overview" element={<Overview />} />
    <Route path="analytics" element={<AnalyticsDashboard />} />
    <Route path="audit" element={<AuditPage />} />
    <Route path="employees" element={<Employees />} />
    <Route path="sso" element={<Sso />} />
    <Route path="organization" element={<Organization />} />
    <Route path="subscription" element={<Subscription />} />
    <Route path="*" element={<section className="ta-page"><h1>Admin page not found</h1><Link to="/app/admin/overview">Go to overview</Link></section>} />
  </Route>;
}
